<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner center">
        <div class="modal">
          <div class="modal-head">
            <h1>업데이트 팝업</h1>
          </div>
          <div class="modal-con">
            <div class="modal-txt">
              <p v-if="!layout.isForce">
                최신 업데이트 버전이 있습니다.<br />
                업데이트 하시겠습니까?
              </p>

              <p v-else>
                필수 업데이트가 있습니다.<br />
                업데이트 하시겠습니까?
              </p>
            </div>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn gray" v-if="!layout.isForce" @click="fnCallBackCancel">나중에</button>
              <button class="btn" @click="fnCallBack">업데이트</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrentInstance } from 'vue';

export default {
  name: 'modal-alert-update',
  emits: ['close'],
  props: {
    layout: {
      type: [Object],
      default: () => {}
    },
    callBack: {
      type: [Function],
      default: () => {}
    },
    callBackCancel: {
      type: [Function],
      default: () => {}
    }
  },
  setup(props) {
    const { proxy } = getCurrentInstance();
    const fnCallBack = event => {
      props.callBack(proxy, event);
    };
    const fnCallBackCancel = event => {
      props.callBackCancel(proxy, event);
    };
    return { fnCallBack, fnCallBackCancel };
  }
};
</script>

<style scoped></style>
